import { render } from "./PatientEcog.vue?vue&type=template&id=6e40938c&scoped=true"
import script from "./PatientEcog.vue?vue&type=script&lang=js"
export * from "./PatientEcog.vue?vue&type=script&lang=js"

import "./PatientEcog.vue?vue&type=style&index=0&id=6e40938c&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/DACY_Demo_Server/kbdemo_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e40938c"]])

export default __exports__